@if (isOpen()) {
  <div class="modal is-active" role="dialog" aria-modal="true" aria-labelledby="declaration-avisos-modal-title">
    <div class="modal-background" (click)="close()"></div>
    <div class="modal-card declaration-avisos-modal">
      <button
        #closeButton
        class="modal-close-button"
        (click)="close()"
        type="button"
        aria-label="Cerrar avisos"
      >
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
      <section class="modal-card-body">
        <h3 id="declaration-avisos-modal-title" class="modal-title">{{ modalTitle }}</h3>

        @if (isLoading()) {
          <p class="loading-message" aria-live="polite">Cargando avisos…</p>
        } @else if (loadError()) {
          <p class="error-message" role="alert">{{ loadError() }}</p>
        } @else {
          <div class="observations-list">
            @if (avisos().length > 0) {
              @for (obs of avisos(); track obs.id) {
                <div class="observation-item">
                  <div class="observation-header">
                    <div class="observation-info">
                      <strong>{{ obs.user?.name }}</strong>
                      <span class="observation-date">{{ obs.created_at | utcDate }}</span>
                      <span class="tag is-warning">Aviso</span>
                    </div>
                  </div>
                  <p class="observation-comment">{{ obs.comment }}</p>
                </div>
              }
            } @else {
              <p class="no-observations">No hay avisos para esta declaración</p>
            }
          </div>
        }

      </section>
    </div>
  </div>
}
